<template>
  <div>
    <b-button
      size="sm"
      variant="primary"
      class="mt-1 mb-1"
      @click="payWithBankTransfer()"
    >
      {{ $t("checkout_control_payment_cash_paynet.pay") }}
    </b-button>
    <div class="legal mt-3 text-justify">
      {{ $t("checkout_control_payment_cash_paynet.legal") }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    payment_configuration: {
      type: Object,
      default: undefined,
    },
    pharmacy_uuid: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    payWithBankTransfer() {
      this.$emit("payment-authorized", {
        pharmacy_uuid: this.pharmacy_uuid,
        payment_conf: this.payment_configuration,
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        checkout_control_payment_cash_paynet: {
          pay: "Pay in store with PayNet",
          legal:
            "Important: If you select this option, you will have a period of 72 hours from this moment to make your Payment, if you do not do so in this period of time, we will return your products for sale and your order will be canceled. The shipment of your product will be made from the confirmation of the payment of your order.",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.legal {
  font-size: $font-size-small;
}
</style>
